/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementH3Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ElementH3Icon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path d="M3 12V4H4V8H7V4H8V12H7V9H4V12H3Z" fill="currentColor" />
              <path
                d="M12.5 5H10V4H12.5C13.3284 4 14 4.67157 14 5.5V6.5C14 6.88418 13.8556 7.23462 13.6181 7.5C13.8556 7.76538 14 8.11582 14 8.5V10.5C14 11.3284 13.3284 12 12.5 12H10V11H12.5C12.7761 11 13 10.7761 13 10.5V8.5C13 8.22386 12.7761 8 12.5 8H11V7H12.5C12.7761 7 13 6.77614 13 6.5V5.5C13 5.22386 12.7761 5 12.5 5Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ElementH3Icon.tags = [
  'heading',
  'h3',
  'text',
  'format',
  'typography',
  'font',
  'style',
];

ElementH3Icon.category = 'Navigator';

ElementH3Icon.iconSize = 16;
